import type { Dispatch, ReactElement, ReactNode, SetStateAction } from 'react'
import { createContext, useContext, useState } from 'react'

import type { Tutorial } from './VideoTutorialModal'

const VideoTutorialStateContext = createContext<Tutorial | undefined>(undefined)
const VideoTutorialDispatchContext = createContext<Dispatch<SetStateAction<Tutorial | undefined>> | undefined>(
  undefined,
)

export function VideoTutorialProvider({ children }: Readonly<{ children?: ReactNode }>): ReactElement {
  const [state, set] = useState<Tutorial | undefined>(undefined)

  return (
    <VideoTutorialDispatchContext.Provider value={set}>
      <VideoTutorialStateContext.Provider value={state}>{children}</VideoTutorialStateContext.Provider>
    </VideoTutorialDispatchContext.Provider>
  )
}

export function useVideoTutorialState(): Tutorial | undefined {
  return useContext(VideoTutorialStateContext)
}

export function useVideoTutorialSetter(): Dispatch<SetStateAction<Tutorial | undefined>> {
  const setter = useContext(VideoTutorialDispatchContext)

  if (!setter) {
    throw new Error(
      'Context value undefined. The hook useVideoTutorialSetter must be used within a VideoTutorialProvider',
    )
  }

  return setter
}
